<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12">
          <v-btn @click="goBack">
            <v-icon>
              mdi-arrow-left
            </v-icon>
            Назад
          </v-btn>
        </v-col>
        <v-col cols="12">
          Добавление шины
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.name"
                  label="Наименование"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.secondName"
                  label="Альтернативное наименование"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.tireBrandId" :items="brands" item-value="id" item-text="name" label="Бренд" dense>
              </v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.diameter" :items="diameters" label="Диаметр" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.width" :items="widths" label="Ширина" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.height" :items="heights" label="Высота" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.season" :items="seasons" item-value="key" item-text="title" label="Сезон" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.amount"
                  label="Количество"
                  type="number"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.price"
                  label="Цена"
                  type="number"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.dealerPrice"
                  label="Дилерская цена"
                  type="number"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-file-input
                  v-model="photo"
                  label="Фото шины"
                  truncate-length="15"
                  dense
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.isForSale" :items="selects" label="Для продажи" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.isHidden" :items="selects" label="Скрыть" dense />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-btn @click="addTire" color="primary">
        Добавить
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>

import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'TireAdd',
  data () {
    return {
      selects: ['Да', 'Нет'],
      valid: true,
      form: {
        name: '',
        tireBrandId: '',
        diameter: '',
        width: '',
        height: '',
        season: '',
        price: '',
        secondName: '',
        dealerPrice: '',
        isForSale: '',
        isHidden: '',
      },
      photo: null,
      seasons: [
        { key: 'ALL', title: 'Всесезонные'},
        { key: 'SUMMER', title: 'Летние'},
        { key: 'WINTER', title: 'Зимние'},
      ],
      diameters: ['13', '14', '15', '16', '17'],
      widths: ['185', '195', '205', '215'],
      heights: ['55', '60', '65', '70'],
      brands: []
    }
  },
  mounted() {
    this.getTireBrands()
  },
  methods: {
    goBack () {
      this.$router.go(-1);
    },
    async getTireBrands() {
      try {
        this.brands = await this.$store.dispatch('tire/getTireBrands')
      } catch (e) {
        console.log(e)
      }
    },
    async addTire () {
      try {
        const formData = new FormData()
        formData.append('name', this.form.name)
        formData.append('secondName', this.form.secondName)
        formData.append('diameter', this.form.diameter)
        formData.append('tireBrandId', this.form.tireBrandId)
        formData.append('width', this.form.width)
        formData.append('season', this.form.season)
        formData.append('height', this.form.height)
        const tire = await this.$store.dispatch('tire/createTire', formData)
        const data = {
          amount: parseInt(this.form.amount),
          dealerPrice: parseInt(this.form.dealerPrice),
          isForSale: this.form.isForSale === 'Да',
          isHidden: this.form.isHidden === 'Да',
          price: parseInt(this.form.price),
          tireId: tire.id
        }
        const resp = await this.$store.dispatch('tire/addPartnerTire', data)
        showSnackbar({
          message: "Шина успешно добавлена!",
          color: "success",
          timeout: 3000,
        })
        console.log(resp)
        console.log(tire)
      } catch (e) {
        console.log(e)
        showSnackbar({
          message: "Не удалось добавить шину!",
          color: "error",
          timeout: 3000,
        })
      }
      console.log(this.form)
      console.log(this.photo)
    }
  }
}
</script>
<style scoped>

</style>